import { CtaVisibleContext } from '@contexts/cta-visible'
import { NavbarHeightContext } from '@contexts/navbar-height'
import React, {
  type FC,
  type PropsWithChildren,
  useCallback,
  useContext,
} from 'react'
import { Waypoint } from 'react-waypoint'

export const WaypointProvider: FC<PropsWithChildren> = ({ children }) => {
  const { setIsVisible } = useContext(CtaVisibleContext)
  const { height } = useContext(NavbarHeightContext)

  const onEnter = useCallback(({ waypointTop }: Waypoint.CallbackArgs) => {
    if (waypointTop !== 0) {
      setIsVisible(true)
    }
  }, [])

  const onLeave = useCallback(({ waypointTop }: Waypoint.CallbackArgs) => {
    if (waypointTop !== 0) {
      setIsVisible(false)
    }
  }, [])

  return (
    <Waypoint topOffset={height} onEnter={onEnter} onLeave={onLeave}>
      <div>{children}</div>
    </Waypoint>
  )
}

export default WaypointProvider
